export default __webpack_public_path__ + "30bdf22.png";